import React from 'react';
import RollingLeadForm from './RollingLeadForm';

interface FullWidthStateFormProps {
  state: string;
  cid: string;
}

const FullWidthStateForm: React.FC<FullWidthStateFormProps> = ({
  state,
  cid,
}) => {
  return (
    <div>
      {' '}
      <h4 className="text-3xl font-semibold text-center text-black mt-10">
        Find The Best Deals On Home Solar In {state}
      </h4>
      <div className="rounded-[2rem] md:px-9 py-4 mt-8 text-gray-900 bg-slate-100 mx-4">
        <RollingLeadForm cid={cid} />
      </div>
    </div>
  );
};

export default FullWidthStateForm;
